import { useState, useCallback, useRef } from 'react';

export function useUndoRedo(initialState, maxHistory = 50) {
  const [state, setState] = useState(initialState);
  const historyRef = useRef([{ state: initialState }]);
  const pointerRef = useRef(0);

  const set = useCallback((newState) => {
    const resolved = typeof newState === 'function' ? newState(historyRef.current[pointerRef.current].state) : newState;
    // Truncate any redo history
    historyRef.current = historyRef.current.slice(0, pointerRef.current + 1);
    historyRef.current.push({ state: resolved });
    if (historyRef.current.length > maxHistory) {
      historyRef.current.shift();
    } else {
      pointerRef.current++;
    }
    setState(resolved);
  }, [maxHistory]);

  const undo = useCallback(() => {
    if (pointerRef.current > 0) {
      pointerRef.current--;
      setState(historyRef.current[pointerRef.current].state);
    }
  }, []);

  const redo = useCallback(() => {
    if (pointerRef.current < historyRef.current.length - 1) {
      pointerRef.current++;
      setState(historyRef.current[pointerRef.current].state);
    }
  }, []);

  const canUndo = pointerRef.current > 0;
  const canRedo = pointerRef.current < historyRef.current.length - 1;

  return { state, set, undo, redo, canUndo, canRedo };
}
